import { Component, Input } from '@angular/core';
import { FUNDAMENT_PREFIX } from '@app/fundament/fundament-prefix';
import { IconSize } from '@features/icons/icon-size';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  public isExpanded = false;

  @Input() iconSize: IconSize = IconSize.Large;

  prefix = FUNDAMENT_PREFIX;
}
